import { AuthState } from './types';

const state: AuthState = {
    user: undefined,
    pending: true,
};

export default state;
